import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { Button } from "../design/button";
import { Divider } from "../design/divider";
import { FieldGroup, Fieldset, Label } from "../design/fieldset";
import { Heading } from "../design/heading";
import { Input } from "../design/input";
import { Field } from "../design/fieldset";

import { Text } from "../design/text";
import { Link } from "../design/link";
import LogoHorizontal from "../components/LogoHorizontal";
import { useTenant } from "../contexts/TenantContext";
import { PoweredByLogo } from "../components/PoweredByLogo";

const LoginPage: React.FC = () => {
  const { tenant, loading: loadingTenant } = useTenant();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } catch (error) {
      console.error("Authentication error", error);
      alert(error);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <form
        method="post"
        className="w-full max-w-lg p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800"
        onSubmit={handleSubmit}
      >
        <div className="items-center w-full my-6 text-center">
          {!loadingTenant && (
            <LogoHorizontal
              href="/"
              tenant={tenant}
              className="items-center h-10 mx-auto"
            />
          )}
        </div>
        <Fieldset>
          <Heading className="text-2xl font-semibold text-center">
            Sign in
          </Heading>
          <Divider className="my-6" />
          <FieldGroup>
            <Field>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                aria-label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
              />
            </Field>
            <Field>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                aria-label="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
              />
            </Field>
          </FieldGroup>
          <Divider className="my-6" />
          <Button type="submit" className="w-full" disabled={isSubmitting}>
            {isSubmitting ? "Signing in..." : "Sign in"}
          </Button>
          <div className="my-6 text-center">
            <Text>
              <Link href="/forgot-password" className="hover:underline">
                Forgot your password?
              </Link>
            </Text>
          </div>
          {/* <div className="my-6 text-center">
            <Text>
              Don't have an account?{" "}
              <Link href="/register" className="text-blue-600 hover:underline">
                Sign up here
              </Link>
            </Text>
          </div> */}
        </Fieldset>
      </form>
      <PoweredByLogo />
    </div>
  );
};

export default LoginPage;
